import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  temples: [],
  loading: false,
  error: null,
  filters: {
    category: null,
    timings: null,
    location: null,
  },
};

export const templesSlice = createSlice({
  name: 'temples',
  initialState,
  reducers: {
    setTemples: (state, action) => {
      state.temples = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
  },
});

export const { setTemples, setLoading, setError, setFilters } = templesSlice.actions;

export default templesSlice.reducer;
